module.exports = __webpack_public_path__ + "static/heidi7-8e07857f04070c0a07dd010db3df943a.jpg";